import { combineReducers } from 'redux';
import { ActionType, createAction, createReducer } from 'typesafe-actions';
import { productActions, product } from './product-info';
import { pageModel, pageModelActions } from './page-model';
import { measurementSettings, FETCH_MEASUREMENT_SETTINGS, basket } from './basket';
import { BASKET_SET, BASKET_UPDATE_ITEM } from './basket/ducks/actions';
import { ADD_TO_SHOPPING_LIST_REQUEST, REMOVE_FROM_SHOPPING_LIST_REQUEST } from './shopping-list';

import {
  rootReducer as pageNavigationReducer,
  RESET_NAVIGATION_CONTEXT,
  RESET_NAVIGATION_SECTIONS,
  RESET_NAVIGATION_SECTION,
  ADD_NAVIGATION_SECTION,
  REMOVE_NAVIGATION_SECTION,
} from './page-navigation';
import {
  FETCH_GOODS_SUPPLY_DATA,
  goodsSupply,
  RESET_GOODS_SUPPLY_DATA,
  SET_GOODS_SUPPLY_CASE,
} from './goods-supply';
import {
  FETCH_REVIEWS_PAGE,
  REVIEWS_SORTING_SET,
  ADD_FILTER_BY_SCORE,
  REMOVE_FILTER_BY_SCORE,
  FETCH_REVIEWS_NEXT_PAGE,
  REVIEWS_RESET_FILTER_BY_SCORE,
  REVIEWS_RESET_SORTING,
  reviewsRoot,
} from './reviews';
import {
  yandexSplit,
  RESET_YANDEX_SPLIT_SESSION,
  SET_YANDEX_SPLIT_SESSION,
} from './yandex-split-banner/reducer';

import { FETCH_VARIANTS, RESET_VARIANTS } from './variants';
import { businesUnitsReducer } from './bisiness-units/reducers';
import { relatedProducts } from './related-products';
import { relatedServices } from './related-services';
import { linkedPages, linkedPagesActions } from './linked-pages';
import { loyaltyRewardsReducer } from './product-loyalty-rewards/reducers/loyalty-rewards';
import { productsCompareListsReducer, productsCompareListsActions } from './products-compare';
import { configurationsActions, configurations } from './configurations';

export const DATA_FETCHING_RUNNING = createAction('pdp/DATA_FETCHING/running')();
export const DATA_FETCHING_COMPLETED = createAction('pdp/DATA_FETCHING/completed')();
export const DATA_FETCHING_TIMEOUT = createAction('pdp/DATA_FETCHING/timeout')();
export const DATA_FETCHING_CANCELED = createAction('pdp/DATA_FETCHING/canceled')();

type InProgressActions =
  | ActionType<typeof DATA_FETCHING_RUNNING>
  | ActionType<typeof DATA_FETCHING_COMPLETED>;
const inProgress = createReducer<boolean, InProgressActions>(false)
  .handleAction(DATA_FETCHING_RUNNING, () => true)
  .handleAction(DATA_FETCHING_COMPLETED, () => false);

type TimeIsOutActions = ActionType<typeof DATA_FETCHING_RUNNING> | ActionType<typeof DATA_FETCHING_TIMEOUT>;
const timeIsOut = createReducer<boolean, TimeIsOutActions>(false)
  .handleAction(DATA_FETCHING_RUNNING, () => false)
  .handleAction(DATA_FETCHING_TIMEOUT, () => true);

export const featuresReducer = combineReducers({
  pageModel,
  linkedPages,
  product,
  basket,
  measurementSettings,
  pdpNavigation: pageNavigationReducer,
  goodsSupply,
  reviews: reviewsRoot,
  businesUnits: businesUnitsReducer,
  dataFetching: combineReducers({
    inProgress,
    timeIsOut,
  }),
  relatedProducts,
  relatedServices,
  loyaltyRewards: loyaltyRewardsReducer,
  productsCompareLists: productsCompareListsReducer,
  configurations,
  yandexSplit,
});

export const featuresActions = {
  productActions,
  pageModelActions,
  linkedPagesActions,
  basketActions: { BASKET_SET, BASKET_UPDATE_ITEM },
  measurementSettingsActions: { FETCH_MEASUREMENT_SETTINGS },
  wishlistActions: { ADD_TO_SHOPPING_LIST_REQUEST, REMOVE_FROM_SHOPPING_LIST_REQUEST },
  pageNavigationActions: {
    RESET_NAVIGATION_CONTEXT,
    RESET_NAVIGATION_SECTIONS,
    RESET_NAVIGATION_SECTION,
    ADD_NAVIGATION_SECTION,
    REMOVE_NAVIGATION_SECTION,
  },
  goodsSupplyActions: { FETCH_GOODS_SUPPLY_DATA, RESET_GOODS_SUPPLY_DATA, SET_GOODS_SUPPLY_CASE },
  productVariantsActions: { FETCH_VARIANTS, RESET_VARIANTS },
  reviewsActions: {
    FETCH_REVIEWS_PAGE,
    FETCH_REVIEWS_NEXT_PAGE,
    REVIEWS_SORTING_SET,
    ADD_FILTER_BY_SCORE,
    REMOVE_FILTER_BY_SCORE,
    REVIEWS_RESET_FILTER_BY_SCORE,
    REVIEWS_RESET_SORTING,
  },
  productsCompareListsActions,
  configurationsActions,
  yandexSplitActions: { SET_YANDEX_SPLIT_SESSION, RESET_YANDEX_SPLIT_SESSION },
};
